export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-page-delete-bce6910ab1e18cb99939e6f76188082e.svg";